<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="addlinks-dialog"
  >
    <wechat-form
      ref="form"
      :form-data="formData"
      @submit="submitHandle"
    ></wechat-form>
  </sliderBarDialogShell>
</template>

<script>
import { editWechatConfig } from '@/api/sys/robitConfig/wechat'
import wechatForm from '@/components/sys/robitCofig/wechat/wechatForm'

export default {
  name: 'editweChat',
  components:{
    wechatForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
    }
  },
  data() {
    return {
      title: '修改企业微信推送渠道'
    }
  },

  methods: {
    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$emit('close');
    },
    beforeClose(){
      this.close();
    },
    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(formData){
        let params = {
            id: formData.id,
            name: formData.robitName,
            desc: formData.desc,
            hookUrl: formData.hookUrl,
            status: formData.status,
        }
        editWechatConfig(params).then((res) => {
            this.$refs.form.$refs.form.clearValidate();
            this.$refs.form.$refs.form.resetFields();
            this.$emit('edit-success');
            this.$refs.form.reset();
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.addlinks-dialog {
  .el-select {
    width: 100%;
  }
}
</style>
<style>
@media screen and (min-width: 768px) {
  .addlinks-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
